import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ShToastModule } from '@stylehaven/components';
import { ToastsContainerComponent } from './containers/toasts-container.component';

@NgModule({
    declarations: [ToastsContainerComponent],
    imports: [CommonModule, ShToastModule],
    exports: [ToastsContainerComponent]
})
export class ToastsModule {}

export { ToastsContainerComponent } from './containers/toasts-container.component';
